import React from 'react';

import * as styles from 'src/dlc_styles/dlcHeader.module.css'

function DLCHeader ({title}) {

    let header_classes=["no-thumb", styles.dlc_header_wrapper].join(' ')

    let image_styles = {};
    image_styles.backgroundImage = "url('/assets/dlc-header.png')";

    return (<>
        <div className={header_classes} id="rotator">
            <div id={styles.header_wrapper} >
                <div id={styles.dlc_header} style={image_styles}></div>
            </div>
            
        </div>
    </>)		
}

export default DLCHeader
